// React
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// React Async
import Async from "react-async";

// Flex Layout
import {
  Modal,
  Button,
  Table,
  Badge,
  Row,
  Col,
  Container,
  DropdownButton,
  Dropdown,
  Spinner,
  Form
} from "react-bootstrap";
// import { } from "react-simple-flex-grid";
import "react-simple-flex-grid/lib/main.css";

// Screenshot
import html2canvas from "html2canvas";

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";
import * as ModelCache from "../libs/ModelCache";
import { func } from "prop-types";

// Components
import ListTable from "../components/ListTable";
import ListSidePane from "../components/ListSidePane";
import ListTagsTypeahead from "../components/ListTagsTypeahead";

import DatePicker from "react-datepicker";
// import '../../node_modules/react-datepicker/dist/es/react-datepicker.css';

// UUID
const uuidv4 = require("uuid/v4");

// DateTime
const { DateTime } = require("luxon");

export default function UserContainer({user, ...props}) {
  const [lists, setLists] = useState([]);
  const [listsInfo, setListsInfo] = useState({});
  const [notesToUserInfo, setNotesToUserInfo] = useState({});
  const [notes, setNotes] = useState([]);

  if (!user) {
    return (<></>);
  }

  function formatTime(unixTime) {
    const timeObject = DateTime.fromMillis(parseInt(unixTime)).setZone(
      "America/Los_Angeles"
    );
    const timeString = timeObject.toLocaleString(DateTime.DATE_MED);
    return <p>{timeString}</p>;
  }

  function renderIndividualList(listid) {
    if (
      listsInfo[listid] === null ||
      typeof listsInfo[listid] === "undefined"
    ) {
      ModelCache.getListForId(
        listid,
        result => {
          var info = listsInfo;
          if (result != null && typeof result !== "undefined") {
            info[listid] = result;
          } else {
            info[listid] = {};
          }
          setListsInfo(info);
        }
      );
      return <></>;
    } else {
      const listEntry = listsInfo[listid];

      var notesForPerson = [];
      for (var k = 0; k < notes.length; k++) {
        const note = notes[k];
        if (note.listid === listid) {
          notesForPerson.push(note);
        }
      }

      return (
        <>
          <hr />
          <Link
            to={`list/${listEntry.listid}`}
            key={listEntry.listid}
            className="contactDetailsList"
          >
            {listEntry.name}
          </Link>
          {notesForPerson.length > 0 ? (
            renderNotesForList(notesForPerson)
          ) : (
            <p>No Notes</p>
          )}
        </>
      );
    }
  }

  function renderLists(chonks) {
    return (
      <div>{chonks.map((list, n) => renderIndividualList(list.listid))}</div>
    );
  }

  function renderNotesForList(notes) {
    return (
      <>
        {notes.map((note, n) => (
          <div>{renderIndividualNote(note)}</div>
        ))}
      </>
    );
  }

  function renderIndividualNote(note) {
    var user = notesToUserInfo[note.userid];
    if (user === null || typeof user === "undefined") {
      ModelCache.getUserById(
        note.userid,
        user => {
          var local = notesToUserInfo;
          local[note.userid] = user;
          setNotesToUserInfo(local);
        }
      );
    }

    return (
      <>
        {user !== null && typeof user !== "undefined" ? (
          renderUser(user)
        ) : (
          <></>
        )}
        <div key={`time_${note.noteid}`}>{formatTime(note.updated)}</div>
        <p key={note.noteid} className="contactDetailsNote">
          {note.notes}
        </p>
      </>
    );
  }

  function renderUser(user) {
    return <img className="avatar sm" src={user.picture} />;
  }

  //<div className={`${props.isvisible ? "active main-panel" : "hidden"}`}>

  return (
    <div className="main-panel">
      <div className="custom-table-container">
        <div className="contact-details_header">
          <img className="avatar lg" src={user.picture} />
          <h4>
            {user.fullName === null || typeof user.fullName === "undefined"
              ? "Loading..."
              : user.fullName}
          </h4>
        </div>
        <div className="contact-details">
          <p>{user.email}</p>
          <p>Current Role: {user.role}</p>
          <DropdownButton
            title="Select New Role"
            variant="Secondary"
            id="dropdown-variants-secondary"
            key="secondary"
          >
            <Dropdown.Item eventKey="1">Owner</Dropdown.Item>
            <Dropdown.Item eventKey="2">Contributor</Dropdown.Item>
          </DropdownButton>
        </div>
      </div>
    </div>
  );
}
